export default "__VITE_ASSET__841a0ba4__"